import { NivosUser } from 'types/user'

const Types = {
  SET: '@@user/SET',
  UPDATE: '@@user/UPDATE'
}

export type Payload = NivosUser

export { Types }
